export const SUPPORTED_FUNCTIONS = {
    REPORT_MODAL: "REPORT_MODAL",
    CLOSE_MODAL:"CLOSE_MODAL"
}